/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/lists.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Lists redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Saturday, May 20, 2023 - 3:20 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/05/20  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listgroupid: 0,
  parentid: 0,
  parentcompanyid: 0,
  companyid: 0,
  listid: 0,
  parentitemid: 0,
  page: "",
  error: null,
  defaultToolPanel: "filter",
  listgrouporder: "NAME ASC",
  listorder: "NAME ASC",
  listitemorder: "ORDERID ASC",
  search: "",
  columnStateListGroup: [],
  columnStateList: [],
};

const intFields = ["listgroupid", "parentid", "parentcompanyid", "companyid", "listid", "parentitemid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const listSlice = createSlice({
  name: "lists",
  initialState,
  reducers: {
    updateListGroupID: (state, action) => updateFieldReducer(state, action, "listgroupid"),
    updateParentID: (state, action) => updateFieldReducer(state, action, "parentid"),
    updateParentCompanyID: (state, action) => updateFieldReducer(state, action, "parentcompanyid"),
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateListID: (state, action) => updateFieldReducer(state, action, "listid"),
    updateParentItemID: (state, action) => updateFieldReducer(state, action, "parentitemid"),
    updatePage: (state, action) => updateFieldReducer(state, action, "page"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnStateListGroup: (state, action) => updateFieldReducer(state, action, "columnStateListGroup"),
    updateColumnStateList: (state, action) => updateFieldReducer(state, action, "columnStateList"),
  },
});

export const {
  updateListGroupID,
  updateParentID,
  updateParentCompanyID,
  updateCompanyID,
  updateListID,
  updateParentItemID,
  updatePage,
  updateDefaultToolPanel,
  updateColumnStateListGroup,
  updateColumnStateList,
} = listSlice.actions;

export default listSlice.reducer;
